module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.news()
      }
    }
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "title is-3"
  }, [_vm._v("Contáctenos")]), _vm._v(" "), _c('a', {
    staticClass: "button customButton",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Click aquí")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Acerca de Hipromeasa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-6 is-vertical is-parent"
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title is-6 infoTitle"
  }, [_vm._v("Higiene, Protección y Medio Ambiente, S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "infoClass"
  }, [_vm._v("\n                Somos una empresa centroamericana dedicada a importar, producir y distribuir productos utilizados para el combate y la protección contra las plagas que afectan la higiene y la salud de los seres humanos, sus animales, sus productos de manufactura, sus mercancías en almacenamiento y su entorno. "), _c('br'), _c('br'), _vm._v("\n                Nuestra empresa cuenta con personal con más de 25 años de experiencia en los campos de higiene, protección y medio ambiente en la región de Centroamérica y El Caribe. Lo que nos permite brindar asesoría técnica y capacitación calificadas en el control de plagas, incluyendo el manejo integrado de las mismas,\n                la selección de las mejores alternativas químicas de control en caso de ser necesarias, recomendaciones de uso de productos y técnicas de aplicación. Todo esto con las debidas consideraciones costo/beneficio, a la par de la efectividad, la seguridad para los operadores y los habitantes y el respeto del medio ambiente."), _c('br'), _c('br'), _vm._v("\n                Contamos con un portafolio con productos reconocidos de prestigiados fabricantes, así como con una amplia gama de productos propios formulados localmente bajo los más altos estándares de calidad, con ingredientes activos certificados bajo las normas ISO, y a la medida de sus necesidades."), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-vertical is-parent"
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title is-6 infoTitle"
  }, [_vm._v("Nuestra Misión")]), _vm._v(" "), _c('p', {
    staticClass: "infoClass"
  }, [_vm._v("\n                Alcanzar la posición de líderes, proveyendo productos y servicios profesionales adaptados a cada uno de los mercados que servimos, a un precio justo, que proporcionen ventajas técnicas, económicas y ecológicas, con una atención de primera clase, ofrecida por personas comprometidas con la excelencia, para la satisfacción de nuestros clientes.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title is-6 infoTitle"
  }, [_vm._v("Nuestra Visión")]), _vm._v(" "), _c('p', {
    staticClass: "infoClass"
  }, [_vm._v("\n                Ser los líderes en cada uno de los mercados que servimos, a través de la maximización de la calidad en el servicio, los niveles de venta, los porcentajes de participación de mercado y la rentabilidad de la empresa.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title is-6 infoTitle"
  }, [_vm._v("Nuestros Objetivos")]), _vm._v(" "), _c('p', {
    staticClass: "infoClass"
  }, [_vm._v("\n                Nuestro compromiso es la permanente actualización, modernización y búsqueda de más y mejores alternativas de combate contra las plagas, de manera que podamos ofrecer constantemente a nuestros clientes más opciones, tecnología de vanguardia y soluciones adecuadas a sus problemas de control de plagas.\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-510e570f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutComponent.vue
// module id = 84
// module chunks = 0